import { Row } from 'antd';
import styled from 'styled-components';

export const EventRow = styled(Row)`
  padding-bottom: 15px;
  margin-bottom: 30px;
`;

export const EventDateTimeRow = styled(Row)`
  .ant-col > p {
    color: #637984;
    font-weight: 900;
    line-height: 18px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;

export const EventContentRow = styled(Row)`
  p {
    height: 72px;
    max-height: 72px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
